<ng-container>
  <portal-agreement-list
    [agreements]="agreements"
    [loading]="loading"
    [tenancyId]="tenancy?.id">
  </portal-agreement-list>
</ng-container>
